import { useSelector } from "react-redux";
import { baseApi } from "./apiConfig";
import { baseApiSell } from "./apiConfig";
import { store } from "@/store/store";

export const getWatchListing = async (propertyId = 0) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/watchListing/${propertyId}?_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching watch listing:", error);
    throw error;
  }
};

export const deleteFavorite = async (propertyId) => {
  try {
    const payload = { propertyId: propertyId };
    const response = await baseApi.post("portal/deleteWatch", payload);
    return response.data;
  } catch (error) {
    console.error("Error deleting favorite:", error);
    throw error;
  }
};

export const getAllCFDProperties = async ({ pageNumber = 1, filters = {} }) => {
  try {
    const state = store.getState();
    const userID = state?.user?.user?.realbidUserId;

    // Construct base query parameters
    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize: 10,
      userId: userID,
    });

    // Append filters only if they exist
    if (filters.propertyType && filters.propertyType.length > 0) {
      queryParams.append("propertySubType", filters.propertyType.join(","));
    }
    // Add occupancyStatus if exists (join array with commas)
    if (filters.occupancy && filters.occupancy.length > 0) {
      queryParams.append("occupancyStatus", filters.occupancy.join(","));
    }

    if (filters.timeFrame === "") {
      queryParams.append("sortBy", "newest");
    } else queryParams.append("sortBy", filters.timeFrame);

    const response = await baseApi.post(
      `/portal/all-cfd-listings?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching saved properties:", error);
    throw error;
  }
};

export const getSavedCFDProperties = async (pageNumber = 1) => {
  try {
    const state = store.getState();
    const userEMail = state?.user?.user?.userEmailId;

    const payload = {
      emailId: userEMail,
      pageNumber: pageNumber,
      pageSize: 10,
      isCfd: true,
    };

    const response = await baseApi.post(
      `/portal/drawer/getUserSavedProperties`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching saved properties:", error);
    throw error;
  }
};

export const getHistoryCFDProperties = async (
  pageNumber = 1,
  sortBy = "placedOn"
) => {
  try {
    const response = await baseApi.post(
      `/portal/cfdOfferHistory?pageNumber=${pageNumber}&pageSize=10&sortBy=${sortBy}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching saved properties:", error);
    throw error;
  }
};

export const getCfdPropertyOfferHistory = async (propertyId) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/all-cfd-offers-of-user-by-property?propertyId=${propertyId}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCfdPropertyDisclaimer = async (propertyId) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApiSell.get(
      `/cust-care/cfd/getCfdDisclaimers/${propertyId}?_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const didYouMeanCfdSuggestions = async (query) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/v2.0/didyoumean?isCFD=Y&query=${query}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCfdSearchUrl = async ({ locationId, locationType }) => {
  try {
    const timestamp = new Date().getTime();
    const isCfdParam = locationType === "ADDRESS_CFD" ? "&isCFD=Y" : "";
    const response = await baseApi.get(
      `/portal/getSearchUrl?id=${locationId}&type=${locationType}${isCfdParam}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCfdPropertiesBySearchUri = async ({
  filters = {},
  searchURI,
  pageNumber = 1,
}) => {
  try {
    const queryParams = new URLSearchParams();

    // Add base parameters
    queryParams.append("isCFD", "Y");
    //queryParams.append("ajax", "true");

    // Append property types - handle multiple values
    if (filters.propertyType && filters.propertyType.length > 0) {
      filters.propertyType.forEach((type) => {
        queryParams.append("propertySubType", type);
      });
    }

    // Add occupancy status - handle multiple values
    if (filters.occupancy && filters.occupancy.length > 0) {
      filters.occupancy.forEach((status) => {
        queryParams.append("occupancyStatus", status);
      });
    }

    // Add time frame / sort
    if (filters.timeFrame === "") {
      queryParams.append("sortBy", "newest");
    } else {
      queryParams.append("sortBy", filters.timeFrame);
    }

    // Add pagination parameters
    queryParams.append("pageNumber", pageNumber);
    queryParams.append("pageSize", 10);

    const separator = searchURI.includes("?") ? "&" : "?";

    const response = await baseApi.get(
      `/portal/${searchURI}${separator}${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const onCfdSavePress = async ({ propertyId }) => {
  try {
    const timestamp = new Date().getTime();

    const response = await baseApi.post(
      `/portal/watchProperty/${propertyId}?notifyType=DAILY&isCFD=true&_=${timestamp}`
    );
    const { status } = response;
    if (status === 200) {
      return "success";
    } else {
      throw response;
    }
  } catch (error) {
    console.error("SRP Save error", error);
  }
};

export const onCfdUnsavePress = async ({ propertyId }) => {
  try {
    const response = await baseApi.post(`/portal/drawer/deleteSavedProperty`, {
      propertyId,
    });
    const { status } = response;
    if (status === 200) {
      return "success";
    } else {
      throw response;
    }
  } catch (error) {
    console.error("SRP Unsave error", error);
  }
};

export const getCfdPropertyOfferSummaryHistory = async (
  propertyId,
  offerId
) => {
  try {
    const response = await baseApi.post(
      `/portal/cfdOfferSummary/${propertyId}/${offerId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCfdPropertyDetailsForOffer = async (propertyId) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/v2.0/getPropertyDetail/${propertyId}?isCFD=Y&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCfdPropertyBuyerPremium = async (propertyId, offerAmount) => {
  try {
    const timestamp = new Date().getTime();

    const response = await baseApi.get(
      `/portal/buyerPremium/${propertyId}/${offerAmount}?isCFD=Y&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const submitCfdPropertyOffer = async (
  buyerPremiumAmount,
  offerAmount,
  propertyId
) => {
  try {
    const state = store.getState();
    const userID = state?.user?.user?.realbidUserId;

    const payload = {
      buyerPremiumAmount: buyerPremiumAmount,
      offerAmount: offerAmount,
      propertyId: propertyId,
      offerSubmitter: userID,
    };
    const response = await baseApi.post(
      `/portal/v2.0/submit-cfd-offer`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};
